<template>
  <div class="control-execute">
    <query-bar
      :query="query"
      @query="onClickQuery"
      :tradingStatus="tradingStatus"
      :channelRouting="channels"
    />

    <list-data :loading="showLoading" :list-data="listData" />

    <common-page :page-data="pageData" @change="onChangePage">
      <router-link class="button" slot="right-aside" to="/riskControl"
        >风控云台</router-link
      >
    </common-page>
  </div>
</template>

<script>
import queryPage from '@/mixins/queryPage'
import QueryBar from './components/QueryBar'
import ListData from './components/ListData'
export default {
  mixins: [queryPage],
  components: {
    QueryBar,
    ListData
  },

  data() {
    return {
      querys: {
        bankCode: '', // 渠道路由-code
        bankName: '', // 渠道
        companyId: '', // 收单机构/管辖机构
        endTime: '', // 交易结束时间
        merName: '', // 交易商户
        merNo: '', // 商户号
        orderId: '', // 交易流水号
        startTime: '', // 交易开始时间
        status: '', // 交易状态
        supId: '', // 供应商号
        supName: '' // 供应商
      },
      tradingStatus: [
        { value: '', label: '全部' },
        { value: '0', label: '待支付' },
        { value: '1', label: '交易成功' },
        { value: '2', label: '交易失败' },
        { value: '3', label: '远期账单待确认' },
        { value: '4', label: '远期账单待退款' },
        { value: '5', label: '退款成功' },
        { value: '6', label: '退款失败' },
        { value: '7', label: '远期账单待结算' }
      ]
    }
  },

  created() {
    const orderId = this.$route.query.orderId

    if (orderId) {
      this.query.orderId = orderId
    }

    this.getChannelList()
  },

  methods: {
    getListData() {
      const {
        query,
        $store: { dispatch },
        pageData: { currentPage, pageSize }
      } = this
      const dispatchEvent = 'T3/riskControlExecute/getListData'

      return dispatch(dispatchEvent, {
        ...query,
        pageSize,
        currentPage
      }).then(({ list, total }) => {
        this.listData = list
        this.pageData.total = total
      })
    }
  }
}
</script>
